import styled from 'styled-components';
import { SELECTOR_POSITION } from './constants';

export const SelectorContainer = styled.div`
	position: absolute;
	bottom: ${({ $bottom }) => $bottom || SELECTOR_POSITION.default}px;
	right: ${SELECTOR_POSITION.right}px;
	z-index: 19;
`;

export const SelectorButton = styled.button`
	position: relative;
	width: 40px;
	height: 40px;
	border-radius: 8px;
	border: 1px solid rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.1);
	/*	background: rgba(${({ theme }) => theme.colors.panelBackgroundRgb}, 0.7); */
	background: ${({ theme }) => theme.colors.background};
	color: ${({ theme }) => theme.colors.textColor};
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.15s ease;
	backdrop-filter: blur(12px);

	&:hover {
		background: rgba(${({ theme }) => theme.colors.panelBackgroundRgb}, 0.85);
		transform: scale(1.05);
	}

	/* Operational indicator */
	&::before {
		content: '';
		position: absolute;
		top: 3px;
		right: 3px;
		width: 6px;
		height: 6px;
		background: ${({ theme, $indicatorColor }) => $indicatorColor || theme.colors.green};
		border-radius: 100vw;
	}
`;

export const SelectorPanel = styled.div`
	position: absolute;
	bottom: 48px;
	right: 0;
	/*	background: rgba(${({ theme }) => theme.colors.panelBackgroundRgb}, 0.7); */
	background: ${({ theme }) => theme.colors.background};

	border: 1px solid rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.1);
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
	padding: 12px;
	min-width: 280px;
	animation: slideUp 0.15s ease;
	/* backdrop-filter: blur(16px); */

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(8px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const PanelHeader = styled.div`
	padding-bottom: 8px;
	margin-bottom: 12px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.border};

	display: grid;
	align-items: end;
	grid-template-columns: 1fr auto;
	column-gap: 12px;
`;

export const PanelTitle = styled.div`
	font-size: 0.75rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: ${({ theme }) => theme.colors.textAccent};
`;

export const IndicatorText = styled.p`
	${({ $variant }) => {
		switch ($variant) {
			case 'success':
				return `
				--color: #28a745;
				--background: #28a74520;
			`;
			case 'warning':
				return `
				--color: #ac6820;
				--background: #ac682020;
			`;
			default:
				return `
				--color: #ac2020;
				--background: #ac202020;
			`;
		}
	}}

	margin: 0;
	background: var(--background);
	color: var(--color);
	font-weight: 500;
	font-size: 0.825rem;
	padding: 3px 5px;
	border-radius: 4px;
`;

export const OptionsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const OptionButton = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 10px;
	border: none;
	border-radius: 4px;
	background: ${({ $selected, theme }) =>
		$selected ? theme.colors.green + '20' : 'transparent'};
	color: ${({ $selected, theme }) => ($selected ? theme.colors.green : theme.colors.textColor)};
	cursor: pointer;
	text-align: left;
	font-size: 0.9rem;
	transition: all 0.1s ease;

	&:hover {
		background: ${({ $selected, theme }) =>
			$selected ? theme.colors.green + '30' : theme.colors.backgroundAccent + '30'};
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;

		&:hover {
			background: transparent;
		}
	}
`;

export const OptionIcon = styled.span`
	display: flex;
	align-items: center;
	width: 20px;
`;
